<template>
    <q-card bordered flat class="column full-height full-width">
        <q-form @submit.prevent="add">
            <q-card-section>
                <div class="text-h6">Копировать задачу {{ task?.code }} в
                </div>
                <q-select v-model="selectedProject" emit-value map-options option-label="name" option-value="id"
                    :options="projects" :loading="isProjectLoading" label="Проект" />
            </q-card-section>
            <q-separator />
            <q-card-section :horizontal="!$q.screen.xs">
                <q-card-section class="col-6">
                    <div class="text-subtitle2">Параметры задачи</div>
                    <q-input v-model="newTask.name" label="Имя задачи" :rules="[requiredRule]" />
                    <q-input v-model="newTask.description" type="textarea" label="Описание" />
                    <q-input v-model.number="newTask.photoCount" type="number" :rules="[requiredRule]"
                        label="Количество фото" />
                    <q-input v-model.number="newTask.priority" type="number" :rules="[requiredRule]" label="Приоритет" />
                    <q-select v-model="newTask.typeId" clearable :loading="isTaskTypeLoading" :options="taskTypes"
                        :rules="[requiredRule]" option-label="name" option-value="id" label="Тип" emit-value behavior="menu"
                        map-options />
                    <q-select use-chips multiple v-model="taskLabels" clearable :loading="isLabelLoading" :options="labels"
                        :rules="[requiredRule]" option-label="name" option-value="id" label="Ярлыки" emit-value
                        behavior="menu" map-options>
                        <template v-slot:no-option>
                            <q-item>
                                <q-item-section class="text-italic text-grey">
                                    Нет доступных ярлыков
                                </q-item-section>
                            </q-item>
                        </template>
                    </q-select>
                    <q-select use-chips multiple v-model="performers" clearable :loading="isUserLoading"
                        :options="performerUsers" :rules="[requiredRule, notEmptyRule]"
                        :option-label="(user) => `${user.username} (${user.email})`" option-value="email"
                        label="Исполнители" emit-value behavior="menu" map-options />
                    <q-input v-model="startTime" label="Дата начала">
                        <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="startTime" mask="YYYY-MM-DD HH:mm">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>

                        <template v-slot:append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="startTime" mask="YYYY-MM-DD HH:mm" format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                    <q-input v-model="executionTime" label="Дата выполнения" :rules="[requiredRule]">
                        <template v-slot:prepend>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-date v-model="executionTime" mask="YYYY-MM-DD HH:mm">
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>

                        <template v-slot:append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="executionTime" mask="YYYY-MM-DD HH:mm" format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                    <q-checkbox v-model="newTask.geo" label="Закрыть галлерею" class="q-my-sm" />

                </q-card-section>
                <q-card-section class="col-6" v-if="selectedType?.propertyDescription.length > 0">
                    <div class="text-subtitle2">Дополнительные параметры</div>
                    <template v-for="property in newTask.properties">
                        <template v-if="property.type === 'STRING'">
                            <q-input v-model="property.value" :label="property.name" :rules="[requiredRule]" />
                        </template>
                        <template v-if="property.type === 'NUMBER'">
                            <q-input v-model.number="property.value" :label="property.name" type="number"
                                :rules="[requiredRule]" />
                        </template>
                        <template v-if="property.type === 'DATE'">
                            <q-input v-model="property.value" :label="property.name" :rules="[requiredRule]">
                                <template v-slot:prepend>
                                    <q-icon name="event" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-date v-model="property.value" mask="YYYY-MM-DD">
                                                <div class="row items-center justify-end">
                                                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                                </div>
                                            </q-date>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </template>
                        <template v-if="property.type === 'DATETIME'">
                            <q-input v-model="property.value" :label="property.name" :rules="[requiredRule]">
                                <template v-slot:prepend>
                                    <q-icon name="event" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-date v-model="property.value" mask="YYYY-MM-DD HH:mm">
                                                <div class="row items-center justify-end">
                                                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                                </div>
                                            </q-date>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>

                                <template v-slot:append>
                                    <q-icon name="access_time" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-time v-model="property.value" mask="YYYY-MM-DD HH:mm" format24h>
                                                <div class="row items-center justify-end">
                                                    <q-btn v-close-popup label="Закрыть" color="primary" flat />
                                                </div>
                                            </q-time>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </template>
                    </template>
                </q-card-section>
                <q-card-section class="col-6" v-else>
                    <div class="text-subtitle2">Дополнительные параметры отсуствуют</div>
                </q-card-section>
            </q-card-section>
            <q-card-actions>
                <q-btn :disable="!selectedProject" no-caps label="Создать" type="submit" color="primary" />
            </q-card-actions>
        </q-form>
    </q-card>
</template>

<script setup lang="ts">
import { useProjectLabels, useProjectUsers, useSelectProjects } from "../../composables/project";
import { useRoute, useRouter } from "vue-router";
import { computed, reactive, ref, watch } from "vue";
import { useAddTask, useTaskTypes, useAddTaskLabels, useAddTaskPerformers, useTask } from "../../composables/task";
import { requiredRule, notEmptyRule } from "../../util/rules";
import { NewTask } from "../../models/task";
import { useDayJs } from "../../composables/dayjs";
import { useEventBus } from "@vueuse/core";
import { taskKey } from "../../util/events";
import { useRouteParams } from "@vueuse/router";
import { priorityOptions } from "../../util/state";

const router = useRouter()
const route = useRoute()
const dayjs = useDayJs()
const taskEvent = useEventBus(taskKey)

const projectId = useRouteParams('projectId', undefined, { transform: Number })
const taskId = useRouteParams('taskId', undefined, { transform: Number })

const selectedProject = ref(projectId.value)
const { data: projects, isFetching: isProjectLoading } = useSelectProjects()

const { data: task, isFetching: isTaskLoading } = useTask(projectId, taskId)
const { data: labels, isFetching: isLabelLoading } = useProjectLabels(selectedProject)
const { data: users, isFetching: isUserLoading } = useProjectUsers(selectedProject)
const { data: taskTypes, isFetching: isTaskTypeLoading } = useTaskTypes(selectedProject)

const performerUsers = computed(() => users.value?.filter(u => u.user.active && u.permission !== "READ").map(u => u.user) ?? [])
const selectedType = computed(() => taskTypes.value?.find(t => t.id === newTask.typeId))
const taskLabels = ref<number[]>([])
const performers = ref<string[]>([])
const executionTime = ref(null)
const startTime = ref(null)

watch(selectedType, val => {
    newTask.properties = val?.propertyDescription.map(d => ({ ...d, value: null })) ?? []
})


const newTask = reactive<NewTask>({
    name: "",
    description: "",
    priority: 0,
    typeId: null,
    properties: [],
    photoCount: 1,
    geo: false,
    executionTime: null,
    startTime: null
})
watch(task, val => {
    newTask.geo = val?.geo ?? false
    newTask.photoCount = val?.photoCount ?? 1
    //newTask.typeId = val?.type.id ?? null
    newTask.description = val?.description ?? ''
    newTask.priority = val?.priority ?? 0
    newTask.name = val?.name ?? ''
    //performers.value = val?.assigned.map(v => v.email).filter(v => users.value?.some(p => p.user.email == v)) ?? []
    //taskLabels.value = val?.labels.map(v => v.id).filter(v => labels.value?.some(p => p.id == v)) ?? []
})

watch(task, val => {
    /*  newTask.properties = val?.type.propertyDescription.map(d => ({
         ...d,
         value: task.value?.properties.find(v => v.code === d.code)?.value
     })) ?? [] */
})
const { data: createdTask, execute: executeAdd } = useAddTask(selectedProject, newTask)
const createdTaskId = computed(() => createdTask.value?.id || -1)
const { execute: executeLabels } = useAddTaskLabels(selectedProject, createdTaskId, taskLabels)
const { execute: executePerformers } = useAddTaskPerformers(selectedProject, createdTaskId, performers)


async function add() {
    newTask.executionTime = dayjs(executionTime.value).utc().format()
    if (startTime.value) {
        newTask.startTime = dayjs(startTime.value).utc().format()
    }
    await executeAdd(true)
    const labels = taskLabels.value
    if (labels.length > 0) {
        await executeLabels()
    }
    const performerEmails = performers.value
    if (performerEmails.length > 0) {
        await executePerformers()
    }
    taskEvent.emit('refresh')
    await router.push(`/projects/${selectedProject.value}/tasks/${createdTaskId.value}`)

}

</script>

<style scoped></style>